module.exports = __webpack_public_path__ + "img/pl.7e450c14.jpg";